import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Caja } from "@/shared/types/caja";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteCaja(id: string): Promise<Caja> {
    await sleep(1000);
    const response = await api.delete("cajas/" + id);
    return response.data;
}

export function useDeleteCajaMutation(id: string, mutationConfig: MutationConfig<Caja> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteCaja(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["cajas"] });
        },
    })
}

export interface DeleteCajaMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Caja>,
    children?:(mutationResult:MutationResult<Caja>)=>ReactNode
}

export function DeleteCajaMutation({
    id,
    children,
    mutationConfig
}:DeleteCajaMutationProps){
    const mutationResult = useDeleteCajaMutation(id, mutationConfig);
    return children&&children(mutationResult)
}